<template>
  <section class="search-form" :class="{'prop': $props.page === 'prop', 'cms': $props.page === 'cms', 'seo': $props.page === 'seo', 'lodge-form': $props.page === 'lodge', 'expand': expandMob }" v-if="(isExternal && $props.page === 'prop') || $props.page !== 'prop'">
    <form id="vueSearchform" class="search_fc" @submit.prevent="checkForm" action="/searches" accept-charset="UTF-8" novalidate="novalidate" method="post">

      <div class="search_loader" :class="{ 'visible': loader }">
        <div class="center">
          <svg class="ico ico--70" @click="checkForm">
            <use xlink:href="#ico-car"></use>
          </svg>
          <p class="search_loadcap" v-if="!errors.postcode">
            Now driving your route
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </p>
          <p class="search_loadcap" v-if="errors.postcode">We can't find your location. Please try again</p>
        </div>
      </div>

      <div class="search-container">
        <h1 v-if="$props.title">{{ $props.title[0] }}<span>{{ $props.title[1] }}</span>{{ $props.title[2] }}</h1>
        <div class="order-box">
          <div class="region-container">
            <input :id="region" v-autofill="" autocomplete="new-password" name="search[region]" :placeholder="$props.page === 'prop' || $props.page === 'cms' ? 'Search elsewhere...' : 'Destination'" type="text" v-model="filter.region" class="search_region" :class="{'drive': showSearch}" @focus="openSearch" @blur="closeSearch">
            <svg class="ico" v-show="!showSearch">
              <use xlink:href="#ico-glass"></use>
            </svg>
            <div class="search_icon" v-cloak="" v-show="showSearch" @click.stop="focusAndClose('#date')">&#x276F;</div>
            <svg class="search_icon_close ico" v-cloak="" @click="clearRegion" v-show="filter.region.length > 0" >
              <use xlink:href="#ico-close"></use>
            </svg>
            <div class="absolute-container" v-show="showSearch">
              <div id="autofill" class="search_drop search_drop--npad"></div>
              <div class="search_drop search_drop--drive" >
                <ul class="history" v-cloak="" v-show="showSearchHistory">
                  <li class="search_drop_item" v-for="recentSearch in recentSearches" v-if="recentSearches.length" @mousedown="goToSearch(recentSearch.id)">
                    <p v-if="recentSearch.region !==''"> {{ recentSearch.region | removeCountry() }}</p>
                    <p v-if="recentSearch.region === '' && recentSearch.travel_origin_postcode !== ''"> {{ recentSearch.travel_max_time / 60 }} hrs from {{ recentSearch.travel_origin_postcode }}</p>
                    <p v-if="recentSearch.region === '' && recentSearch.travel_origin_postcode === ''">Draw a search</p>
                    <span>{{ recentSearch.check_in_on }} - {{ recentSearch.check_in_on | endDate(recentSearch.minimum_nights) }}</span>
                  </li>
                </ul>
                <div class="search_drop search_drop--h fw-bold" @mousedown="toggleSearch" v-show="!showDrive">
                  Or search by driving time
                </div>
                <div class="search_drop search_drop--h" @mousedown="toggleSearch" v-show="!showDrive">
                  From my postcode
                  <svg>
                    <use xlink:href="#ico-compass"></use>
                  </svg>
                </div>
                <div class="search_drop search_drop--h" @mousedown="findMyLocation" v-show="!showDrive">
                  Locate me
                  <svg>
                    <use xlink:href="#ico-pin"></use>
                  </svg>
                </div>
              </div>
            </div>

            <div class="absolute-container drive" v-show="showDrive" :class="{'shadow': showDriveExpanded, 'error': errors.postcode}">
              <div class="search_drop search_drop--drive" v-show="showDrive" >
                <select name="search[travel_max_time]" @change="focusEl('#postcode')" v-model="filter.travel_max_time" data-required="required" data-valid="invalid" class="travelTime form_valid driveSearch" data-active="inactive">
                  <option selected="selected" value="0" disabled="true">Driving time*</option>
                  <option v-for="interval in timeIntervals" :value="interval.value">
                    {{interval.text}}
                  </option>
                </select>
                <span>from</span>
                <input id="postcode" class="search_post form_valid" name="search[travel_origin_postcode]" @blur="closeDrive" @focus="openDrive" data-required="required" data-valid="invalid" data-active="inactive" placeholder="Postcode" v-model="filter.travel_origin_postcode" @change="geoCode" type="text" />
                <svg v-show="!showDriveExpanded" >
                  <use xlink:href="#ico-car"></use>
                </svg>
                <div class="search_icon" v-cloak="" v-show="showDriveExpanded" @click.stop="focusAndClose('#date')">&#x276F;</div>
              </div>

              <div v-show="showDriveExpanded" class="search_drop search_drop--h" @mousedown="findDriveLocation">
                Locate me
                <svg class="ico ico--25">
                  <use xlink:href="#ico-pin"></use>
                </svg>
              </div>
              <div class="search_drop search_drop--h" v-show="showDriveExpanded" @mousedown="toggleSearch">
                Or search by region
                <svg class="ico ico--25">
                  <use xlink:href="#ico-map"></use>
                </svg>
              </div>
            </div>
          </div>
          <Dates
              :data.sync="filter.check_in_on"
              :flex.sync="filter.flex"
              :search="'search[check_in_on]'"
              :placeholder="'Check in*'"
              :error="errors.date"
              :cal="$props.cal"
          />
          <Select
              :options="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]"
              :search="'search[minimum_nights]'"
              :placeholder="'Nights*'"
              :name="'Nights'"
              :data.sync="filter.minimum_nights"
              :error="errors.nights"
          />
          <Select
              :options="['1+', '2+', '3+', '4+', '5+', '6+','7+', '8+', '9+', '10+', '11+','12+','13+', '14+', '15+', '16+', '17+', '18+', '19+', '20+']"
              :search="'search[sleeps]'"
              :name="'Guests'"
              :placeholder="'Guests'"
              :data.sync="filter.sleeps"
          />
          <input type="hidden" name="search[flex]" v-model="filter.flex"/>
          <input type="hidden" v-for="param in $props.params" :name="'search[' + param[0] + ']'" :value="param[1]"  />
          <button class="submit-search btn btn--org btn--lrg btn--wide">Search</button>
          <div class="foot" v-if="$props.page !== 'prop' && $props.page !== 'lodge' && $props.page !== 'cms' && $props.page !== 'seo'">
            <input class="form_valid form_check" id="pets" v-model="filter.pets" type="checkbox"  name="search[pets]"/>
            <label for="pets" class="form_clabel">
              Show me only pet-friendly properties
            </label>
            <div class="search_pnts">
              <h3 class="search_txt">
                <svg class="search_t">
                  <use xlink:href="#ico-tick"></use>
                </svg>
                Live availability
              </h3>
              <h3 class="search_txt">
                <svg class="search_t">
                  <use xlink:href="#ico-tick"></use>
                </svg>
                Live prices
              </h3>
              <h3 class="search_txt">
                <svg class="search_t">
                  <use xlink:href="#ico-tick"></use>
                </svg>
                Book instantly
              </h3>
            </div>
          </div>
        </div>

        <memCTA
            v-if="$props.page !== 'prop' && $props.page !== 'lodge' && $props.page !== 'cms' && $props.page !== 'seo'"
            :classN="'ctr'"
            :cta="'Become a member for free and access exclusive deals'"
            :type="'s'"
        />
      </div>
    </form>
  </section>
</template>

<script>
import Dates from 'shared/propDate.vue'
import Select from 'shared/select.vue'
import memCTA from 'shared/member_cta.vue'
export default {
  data: function () {
    return {
      url: "/searches/custom?",
      currentUrl: window.location.href,
      isExternal: document.referrer.indexOf('snaptrip') === -1,
      timeIntervals: [
        {'value':30, 'text': '30 Mins'},
        {'value':60, 'text': '1 Hour'},
        {'value':90, 'text': '1.5 Hours'},
        {'value':120, 'text': '2 Hours'},
        {'value':150, 'text': '2.5 Hours'},
        {'value':180, 'text': '3 Hours'},
        {'value':210, 'text': '3.5 Hours'},
        {'value':240, 'text': '4 Hours'},
        {'value':270, 'text': '4.5 Hours'},
        {'value':300, 'text': '5 Hours'}
      ],
      recentSearches: [],
      showSearchHistory: true,
      showSearch: false,
      showDrive: false,
      showDriveExpanded: false,
      showClearRegion: false,
      loader: false,
      latLng: {},
      expandMob: false,
      filter: {
        region: this.$props.loc || "",
        travel_origin_postcode: "",
        travel_max_time: 120,
        pets: "",
        check_in_on: "",
        minimum_nights: "",
        sleeps: "",
        flex: 1
      },
      errors: {
        postcode: false,
        nights: false,
        date: false,
        time: false
      }
    }
  },
  props: {
    title: Array,
    region: String,
    params: Array,
    page: Object,
    loc: String,
    wknd: String,
    page: String,
    cal: String
  },
  components: {
    Dates, Select, memCTA
  },
  filters: {
    endDate(date, nights) {
      let result = new Date(date);
      return st.getUserDate(result.setDate(result.getDate() + parseInt(nights)));
    },
    removeCountry(text) {
      return text.replace(/,.*$/g, '');
    }
  },
  methods: {
    postRequest() {
      return {
        method: "POST",
        credentials: "include",
        headers: {
          'X-CSRF-TOKEN': st.getCSRFToken(),
          'Content-Type': "application/json; charset=utf-8"
        }
      };
    },
    hasNumber (value) {
      var filter = /\d/;
      return filter.test(value);
    },
    clearRegion(){
      this.filter.region = "";
      this.showClearRegion = false;
      this.focusEl("#region");
    },
    focusEl(el) {
      let elem = this.$el.querySelector(el);
      if (elem) {
        setTimeout(() => {
          this.$nextTick(() => elem.focus());
        }, 100);
      }
    },
    focusAndClose(el) {
      this.showDriveExpanded = false;
      this.focusEl(el);
    },
    getGeocode (app) {
      st.ajax({
        url: "https://api.mapbox.com/geocoding/v5/mapbox.places/" + encodeURIComponent(app.filter.travel_origin_postcode) + ".json?country=gb&access_token=pk.eyJ1Ijoic25hcHRyaXBrcmlzIiwiYSI6ImNqa2RvejJucDB5bm4zcnM1ZDlyOHVqZnQifQ.VZTOARdDaid-d4yf2Q182g",
        type: "GET",
        dataType: "json"
      }, function(response) {
        if (response.features[0]) {
          app.latLng = { lng: response.features[0].center[0], lat: response.features[0].center[1] };
          app.errors.postcode = false;
        } else {
          app.errors.postcode = true;
        }
      });
    },
    getGeoLocation (app) {
      let scope = this;
      if (navigator.geolocation) {
        app.errors.postcode = false;
        app.filter.travel_origin_postcode = "Finding...";
        navigator.geolocation.getCurrentPosition(function(position) {
          scope.getPostcode({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            data: app
          });
        }, function(error) {
          if (error.code === error.PERMISSION_DENIED) {
            app.toggleSearch();
            app.errors.postcode = true;
          }
        });
      }
    },
    getPostcode (options) {
      let app = options.data;
      st.ajax({
        url: "https://api.mapbox.com/geocoding/v5/mapbox.places/" + encodeURIComponent(options.lng + "," + options.lat) + ".json?access_token=pk.eyJ1Ijoic25hcHRyaXBrcmlzIiwiYSI6ImNqa2RvejJucDB5bm4zcnM1ZDlyOHVqZnQifQ.VZTOARdDaid-d4yf2Q182g",
        type: "GET",
        dataType: "json"
      }, function(response) {
        app.filter.travel_origin_postcode = response.features[0].context[0].text;
        app.latLng = { lng: options.lng, lat: options.lat };
      });
    },
    geoCode () {
      this.getGeocode(this);
    },
    findMyLocation () {
      this.toggleSearch();
      this.getGeoLocation(this);
    },
    findDriveLocation () {
      this.getGeoLocation(this);
    },
    toggleSearch () {
      let app = this;
      app.showDrive = !app.showDrive;
      app.showSearch = !app.showSearch;
      app.showDriveExpanded = !app.showDriveExpanded;
      if (app.showDrive) {
        app.filter.region = "";
        this.focusEl("#postcode");
      } else {
        app.filter.travel_max_time = 120;
        app.filter.travel_origin_postcode = "";
        app.errors.postcode = false;
        this.focusEl("#region");
      }
    },
    openDrive () {
      let app = this;
      app.showDriveExpanded = true;
    },
    closeDrive () {
      let app = this;
      app.showDriveExpanded = false;
    },
    openSearch (e) {
      let app = this;
      app.showSearch = true;
      app.expandMob = true;
    },
    closeSearch() {
      let app = this;
      app.showSearch = false;
    },
    goToSearch (id) {
      window.location.href = id ? "/searches/" + id : "/top-deals";
    },
    //history
    getHistory(item, limit) {
      let history = localStorage.getItem(item),
          newData = [];
      if (st.checkLocal() && history !== null && history.length > 0) {
        newData = JSON.parse(history).slice(0, limit);
        return newData.reverse();
      } else {
        return [];
      }
    },
    cleanSearchHistory () {
      let app = this;
      let today = new Date().getTime(),
          allRecords = app.getHistory("search_history", 10),
          records = [];
      for (let i = 0; i < allRecords.length; i++) {
        let record = allRecords[i];
        if ((record.isochrone_uuid !== "" || record.region !== "" ) && new Date(record.check_in_on).getTime() > today) {
          if (records.length < 3) {
            records.push(record);
          }
        }
      }
      if (records.length === 1 || records.length === 2) {
        app.pushTopDealsCard(records);
      }
      return records;
    },
    pushTopDealsCard(records) {
      let app = this;
      records.push({
        region: "Latest UK deals",
        check_in_on: app.$props.wknd,
        nights: 3,
        minimum_nights: 3,
        isochrone_uuid: ""
      });
    },
    //validation & submission
    checkForm () {
      let scope = this;
      let form = scope.$el.children[0];
      scope.clearAll();
      scope.validateForm(scope, form);
    },
    clearAll () {
      this.errors.nights = false;
      this.errors.date = false;
      this.errors.time = false;
    },
    isRefOnly (value) {
      return this.hasNumber(value);
    },
    validateForm (scope, form) {
      let app = this;
      if (scope.filter.minimum_nights === 0 || scope.filter.minimum_nights === "") {
        scope.errors.nights = true;
      }
      if (scope.filter.check_in_on === "") {
        scope.errors.date = true;
      }
      if (scope.showDrive) {
        app.validateDrive(scope);
        return;
      }
      if (app.isRefOnly(scope.filter.region) || !(scope.errors.date || scope.errors.nights || scope.errors.postcode)) {
        form.submit();
      }
    },
    validateDrive (scope) {
      let app = this;
      this.getGeocode(scope);
      if (scope.filter.travel_origin_postcode === "") {
        scope.errors.postcode = true;
        return;
      }
      if (scope.filter.travel_max_time === "") {
        scope.errors.time = true;
        return;
      }
      if (scope.filter.check_in_on === "") {
        scope.errors.date = true;
        return;
      }
      app.loader = true;
      app.createUrl();
    },
    createUrl() {
      var app = this;
      var search = { search: app.filter };
      this.calcIso({
        time: parseInt(app.filter.travel_max_time),
        position: app.latLng,
        callback: function(response) {
          callback(response, app);
        }
      });
    },
    //isochrone
    calcIso (vars) {
      let scope = this;
      let url = "/api/v2/isochrones?lat=" + vars.position.lat + "&lng=" + vars.position.lng + "&travelTimeInSecs=" + vars.time * 60;
      fetch(url, scope.postRequest())
          .then(function(resp) {
            if (resp.status === 201){
              return resp.json();
            } else {
              scope.errors.postcode = true;
              return;
            }
          })
          .then(function(data) {
            scope.isoCallBack(data, vars.callback, vars.position);
          })
          .catch(error => console.log(error));
    },
    isoCallBack (response, uuidCallback, position) {
      let scope = this;
      let uuid = response._meta.uuid;
      let guests = scope.filter.sleeps ? scope.filter.sleeps : 1;
      scope.uuid = uuid;
      window.location.href = scope.url + "search[isochrone_uuid]=" + uuid + '&search[travel_max_time]=' + scope.filter.travel_max_time + '&search[travel_origin_postcode]=' + scope.filter.travel_origin_postcode + '&search[check_in_on]=' + scope.filter.check_in_on + '&search[minimum_nights]=' + scope.filter.minimum_nights + '&search[sleeps]=' + guests;
    },
    sortSuggestionLists(response, term) {
      let matchedArray = [];
      let unmatchedArray = [];
      let newArray = [];
      let inputValue = term.toUpperCase();
      response.forEach(value => {
        let locationName = value.split(",")[0].toUpperCase();
        if (locationName.indexOf(inputValue) === 0) {
          matchedArray.push(value);
        } else {
          unmatchedArray.push(value);
        }
      });
      newArray = [...matchedArray, ...unmatchedArray];
      return newArray
    }
  },
  directives: {
    'autofill': {
      inserted: (el, binding, vnode) => {
        let af = document.querySelector("#autofill");
        let app = vnode.context,
            url = window.location.href;
        el.autofill = new autoComplete({
          selector: el,
          minChars: 1,
          cache: false,
          source: function (term, suggest) {
            if (term.length > 2) {
              st.ajax({
                url: "/searches/autocomplete?query=" + encodeURIComponent(term.toLowerCase()),
                type: "GET",
                csrf: st.getCSRFToken(),
                dataType: "json"
              }, function (response) {
                let newResponse = app.sortSuggestionLists(response, term);
                suggest(newResponse);
              });
              app.showSearchHistory = false;
            } else {
              app.showSearchHistory = true;
            }
          },
          renderItem: function(item, search) {
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            if(item.includes(",")){
              return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>").replace(",", "+").split("+")[0] + '<br /><span class="sub-region">' + item.replace(re, "<b>$1</b>").replace(",", "+").split("+")[1]  + '</span></div>';
            } else {
              return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
            }
          },
          onSelect: function (e, term, item) {
            e.preventDefault();
            app.filter.region = term;
            app.showSearch = false;
          }
        });
        if (af) {
          af.appendChild(document.querySelector(".autocomplete-suggestions"));
        }
        el.autocomplete = url.indexOf("snaptrip") > -1 && url.indexOf("properties") === -1 ? "new-password" : "off";
      },
      unbind: (el) => {
        el.autofill.destroy();
      }
    }
  },
  mounted: function () {
    let app = this;
    app.recentSearches = app.cleanSearchHistory();
    if (app._props.page === 'seo') {
      document.addEventListener('scroll', function(e) {
        if (window.pageYOffset >= 800) {
          app.$el.closest('.following-form').classList.add('show')
        } else {
          app.$el.closest('.following-form').classList.remove('show')
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
.search-form {
  padding: 1.25rem;
  &.prop,
  &.cms,
  &.seo,
  &.lodge-form {
    position: relative;
    top: 0;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    height: auto;
    overflow: auto;
    &.expand {
      overflow: visible;
    }
    .history li span{
      margin: 0;
    }
    .search_loader {
      height: 14rem;
    }
    .search_drop--drive span {
      margin: 0;
    }
    .search-container {
      background-image: none;
      background-color: unset;
      padding: 0;
      max-height: 3rem;
      transition: max-height 1s ease;
      .search_icon {
        top: 1rem;
      }
      h1 {
        display: none;
      }
      .order-box {
        padding: 0;
        .box:last-of-type {
          display: none;
        }
      }
      .btn {
        margin: 0;
        width: 100%;
        font-size: 1rem;
      }
      .search_region {
        padding: 0 5rem 0 1rem;
        box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .5);
        &.drive {
          margin-top: 0;
        }
      }
    }
    &.expand .search-container  {
      max-height: 15rem;
    }
    .absolute-container {
      z-index: 4;
      &.drive {
        margin: 0;
        z-index: 4;
        select {
          max-width: 5rem;
        }
      }
    }
    .search_drop{
      &--drive {
        padding: 0;
      }
      &--h {
        z-index: 4;
      }

      &.fw-bold {
        font-weight: 700;
      }
    }
  }
  &.seo .search-container .search_icon {
    top: 1.6rem;
  }
  &.lodge-form .search-container .search_icon {
    top: 1rem;
  }
  h1 {
    padding: 0 1.25rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 3.5rem;
    font-size: 1.5rem;
    text-shadow: 0 .125rem .125rem #221F20;
    position: relative;
    z-index: 2;
    color: #FFF;
    text-align: center;
    span {
      font-weight: 700;
      color: #fff;
    }
  }
  .ico {
    right: 1.25rem;
    position: absolute;
    top: 1rem;
    stroke: #FC5C30;
    stroke-width: 2rem;
    cursor: pointer;
    width: 1.25rem;
    height: 1.25rem;
    z-index: 2;
    &.search_icon_close {
      right: 3.2rem;
      stroke: none;
    }
  }
  .search_icon {
    width: 1.4rem;
    height: 1.4rem;
    right: 1.25rem;
    border-radius: 100%;
    border: none;
    background: #FC5C30;
    color: #FFF;
    text-align: center;
    line-height: 1.4rem;
    position: absolute;
    top: 1rem;
    z-index: 2;
    cursor: pointer;
  }
  .search-container{
    max-width: 40rem;
    margin: 0 auto;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    h1 {
      order: 1;
    }
    .ctr{
      order: 2;
      display: flex;
      width: 100%;
    }
    .order-box {
      order: 3;
      padding: 1.25rem 0 0 0;
    }
  }
  .search_loader {
    display: none;
    border-radius: .19rem;
    width: 100%;
    left: 0;
    bottom: 0;
    height: 24rem;
    position: absolute;
    background: #FFF;
    z-index: 100;
    padding: 1.25rem;
    box-sizing: border-box;
    &.visible {
      display: block;
      .search_loadcap span {
        animation: blink 1.4s infinite;
        animation-fill-mode: both;
        font-size: 1.5rem;
        &:nth-child(2) {
          animation-delay: .2s;
        }
        &:nth-child(3) {
          animation-delay: .4s;
        }
      }
    }
    .center {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .ico {
        width: 4.375rem;
        height: 4.375rem;
        cursor: pointer;
        stroke: #000;
        stroke-width: 0;
        position: relative;
        right:0;
      }
      .search_loadcap {
        margin: 1rem 0 0 0;
      }
    }
  }
  .search-row {
    height: 3.125rem;
    position: relative;
    width: calc(50% - .625rem);
    float: left;
    margin-bottom: 1.25rem;
    box-sizing: border-box;
  }
  .search_region {
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    line-height: 3.125rem;
    font-size: .875rem;
    width: 100%;
    padding: 0 2rem 0 1rem;
    height: 3.125rem;
    line-height: 3.125rem;
    font-size: .875rem;
    outline: 0;
    position: relative;
    cursor: text;
    float: left;
    border-radius: .188rem;
    margin-bottom: 1.25rem;
    box-sizing: border-box;

    &.drive {
      background-color: #EEEEEE;
      border-bottom: .063rem solid transparent;
    }

    &.fw-bold {
      font-weight: 700;
    }

    &::-ms-clear {
      display: none;
    }
  }
  .btn {
    width: calc(50% - .625rem);
    margin: 0 0 0 .625rem;
  }
  svg.search_t {
    height: 1rem;
    width: 1rem;
  }
  .form_clabel {
    float: left;
    width: 100%;
  }
  .search_drop {
    background-color: #FFF;
    box-sizing: border-box;
    max-width: 100%;
    border-radius: .188rem;
    top: 0;
    left: 0;
    z-index: 7;
    max-height: 1000px;
    overflow: initial;
    &--h {
      position: relative;
      height: 100%;
      line-height: 3.125rem;
      font-size: .875rem;
      width: 100%;
      padding: 0 2rem 0 1rem;
      cursor: pointer;
    }
    svg {
      margin-top: -.813rem;
      right: 1.25rem;
      position: absolute;
      top: 50%;
      stroke-width: initial;
      fill: #FC5C30;
      cursor: pointer;
      width: 1.563rem;
      height: 1.563rem;
    }
  }
  .region-container {
    position: relative;
    width: 100%;
  }
  .absolute-container {
    position: absolute;
    box-sizing:border-box;
    top: 0;
    z-index: 1;
    width: 100%;
    padding: 3rem 0 0 0;
    border: .063rem solid #9B9B9B;
    border-radius: .188rem;

    &.drive {
      z-index: 2;
      border: .063rem solid #9B9B9B;
      padding: 0;
      line-height: 3.125rem;
      font-size: .875rem;
      outline: 0;
      background: $col_white;
      float: left;
      &.error{
        border: .063rem solid $col_red;
        color: $col_red;
        input,
        input::placeholder {
          color: $col_red;
        }
      }
      &.shadow {
        box-shadow: 0 0 1.25rem rgba(0, 0, 0, .3);
      }
      .search_drop {
        height: 100%;
        height: 3.125rem;
        padding: 0 2rem 0 1rem;
      }
      select {
        height: 100%;
        font-size: .875rem;
        outline: 0;
        width: auto;
        max-width: 5.625rem;
        font-weight: 700;
        background: transparent;
      }
      span {
        margin: 0 .5rem;
        height: 100%;
        font-size: .875rem;
        outline: 0;
        width: auto;
      }
      input {
        height: 100%;
        line-height: 3.125rem;
        font-size: .875rem;
        outline: 0;
        width: 80%;
        max-width: 5.625rem;
        font-weight: 700;
        &::placeholder {
          font-weight: 400;
        }
      }
    }
  }
  .history {
    box-sizing: border-box;
    list-style: none;
    padding: 0;
    line-height: 3.125rem;
    font-size: .875rem;
    width: 100%;
    cursor: pointer;
    background: $col_white;
    &:after {
      content: '';
      position: absolute;
      width: 90%;
      left: 50%;
      transform: translateX(-50%);
      background: #B4B4B4;
      height: 1px;
      display: block;
      z-index: 8;
    }
    li {
      font-weight: 700;
      text-transform: capitalize;
      width: 100%;
      box-sizing: border-box;
      padding: 1rem;
      font-size: .8rem;
      cursor: pointer;
      &:hover {
        p, span {
          color: $col_orange;
        }
      }
      p {
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-wrap: normal;
        width: 40%;
      }
      span {
        float: right;
        font-weight: 400;
        width: 60%;
        text-transform: uppercase;
        text-align: right;
      }
    }
  }
  .search_pnts {
    padding: 1.25rem 0 0;
    width: 100%;
    position: relative;
    flex-direction: row;
    flex: 1 1 auto;
    display: none;
  }
  .search_txt {
    text-align: center;
    font-weight: 400;
    width: calc(100% / 3);
    font-size: .875rem;
    .search_t {
      width: .875rem;
      top: .125rem;
      height: .875rem;
      position: relative;
      fill: $col_white;
    }
  }
  .foot {
    padding: 1.25rem 0;
    & * {
      color: $col_white;
      text-shadow: 0 .125rem .125rem #221F20;
    }
  }
}
@keyframes blink {
  0% {
    opacity: .2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .2;
  }
}
@media #{$xs-phone} {
  .search-form .history li span {
    font-size: .7rem;
  }
}
@media #{$phablet} {
  .search-form .search-container .order-box {
    padding: 1.25rem;
  }
}
@media #{$desktop} {
  .search-form {
    height: 26.25rem;
    width: 27.5rem;
    position: absolute;
    top: 7.5rem;
    margin: 0 0 0 1.25rem;
    padding: 0;
    &.lodge-form {
      margin-bottom: 2rem;
    }
    &.prop {
      width: calc(100% - 2.5rem);
      margin: 0 0 0 1.25rem;
    }
    &.seo{
      width: 100%;
    }
    &.cms {
      width: calc(100% - 2.5rem);
      margin: 0 0 0 0.5rem;
    }
    &.lodge-form {
      max-width: 90rem;
    }
    &.prop,
    &.cms,
    &.seo,
    &.lodge-form {
      .absolute-container {
        z-index: 4;
        &.drive {
          margin: 0;
          .search_drop {
            height: 3.025rem;
            &--h {
              line-height: 3.025rem;
            }
          }
        }
      }
      .search_loader {
        height: auto;
        .center {
          display: flex;
          justify-content: center;
          align-items: center;
          .ico {
            top:0;
            margin-right: 1rem;
          }
          .search_loadcap {
            margin: 0;
          }
        }
      }
      .search_drop{
        &--h {
          padding: 1rem 2rem 1rem 1rem;
          line-height: 1.5rem;
        }
        svg {
          right: 1.25rem;
        }
      }
      .search-container {
        max-width: none;
        max-height: none;
        width: calc((100% / (12 / 10)) - (1% * 2 / 12));
        box-shadow: none;
        padding: .75rem 0;
        .btn {
          width: calc(50% - .625rem);
          margin: 0 0 0 .625rem;
        }
        .region-container {
          min-width: 18.1rem;
          input {
            margin: 0;
          }
        }
        .order-box {
          display: flex;

          .box:last-of-type {
            display: block;
          }
        }
        .search_region {
          box-shadow: 0 .063rem .125rem rgba(0, 0, 0, 0.3);
        }
      }
    }
    &.seo .search-container {
      width: 100%;
    }
    .search_region {
      border: .063rem solid #9B9B9B;
    }
    h1 {
      margin-bottom: 1.25rem;
      font-size: 1.5rem;
      color: #000;
      text-align: left;
      padding: 0;
      margin-top: 0;
      text-shadow: none;
      span {
        color: #000;
      }
    }
    .search_loader {
      height: 27rem;
      top: 0;
    }
    .search-container{
      padding: 1.25rem;
      background-color: #FFF;
      position: relative;
      box-sizing: border-box;
      border-radius: .19rem;
      box-shadow: 0 0 1.25rem rgba(0,0,0,.3);
      display: block;
      .order-box {
        padding: 0;
      }
    }
    .foot {
      & * {
        color: $col_black;
        text-shadow: none;
      }
      .search_t {
        fill: black;
      }
    }
    .search_pnts {
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
    }
  }
}
</style>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
.search-form.prop,
.search-form.cms,
.search-form.seo,
.search-form.lodge-form{
  .box {
    &.error input.btn{
      border: .063rem solid #e84118;
    }
    input.btn {
      box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .5);
      padding: 0 1rem;
    }
    .select select {
      background: $col_white;
    }
    .select:after {
      border: 1px solid grey;
      border-top: none;
      border-left: none;
      content: '';
      display: inline-block;
      height: 0.5rem;
      right: 0.7em;
      position: absolute;
      width: 0.5rem;
      box-sizing: border-box;
      top: 1.1rem;
      transform: rotate(45deg);
    }
  }
}
.search-form {
  .box input,
  .box .select {
    box-shadow: 0 .125rem .25rem rgba(0,0,0,.5);
  }
  .box {
    display: inline-block;
    width: calc(50% - .625rem);
    float:left;
    margin: 0 .625rem 0 0;
    .select {
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg enable-background='new 0 0 500 500' version='1.1' viewBox='0 0 500 500' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate%28-186 -303%29'%3E%3Cg transform='translate%2820 281%29'%3E%3Cg transform='translate%28160 15%29'%3E%3Cpath d='m29.729 155.09c0-4.702 1.671-9.28 5.015-12.817 6.735-7.074 17.638-7.074 24.324 0l193.9 204.46 193.97-204.46c6.688-7.074 17.639-7.074 24.324 0 6.688 7.075 6.688 18.559 0 25.609l-197.48 208.07c-11.51 12.114-30.117 12.114-41.502 0l-197.53-208.07c-3.344-3.513-5.014-8.19-5.014-12.792z' fill='%234B4A4B'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E ");
      background-size: .813rem;
      background-position: right .5rem center;
      background-repeat: no-repeat;
      box-sizing: border-box;
      &:after {
        display: none;
      }
      select {
        padding: .5rem 1rem;
        line-height: 1.2rem;
        font-size: .875rem;
        width: 130%;
        background: transparent;
        font-weight: 400;
        text-transform: capitalize;
      }
    }
    &:nth-of-type(3) {
      margin: 0 0 0 .625rem;
    }
    .btn {
      width: 100%;
      padding: 1rem 0;
    }
    .select {
      height: 3.125rem;
      position: relative;
      width: calc(50% - .625rem);
      float: left;
      margin-bottom: 1.25rem;
      box-sizing: border-box;
      border: none;
      line-height: 3.125rem;
      width: 100%;
      border-radius: .188rem;
      background-color: #FFF;
    }
    input.btn {
      background: $col_white;
      line-height: 3.125rem;
      font-size: .875rem;
      font-weight: 400;
      text-transform: none;
      text-align: left;
      padding: 0 0 0 1rem;
      border: none;
      border-radius: .188rem;
      &::placeholder {
        color: #7F8C8D;
      }
    }
  }
  .autocomplete-suggestion {
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333;
    font-size: .875rem;
    line-height: 1.125rem;
    padding: .75rem 0 .75rem 1rem;
    cursor: pointer;
    .sub-region {
      font-size: .75rem;
    }
    &:hover, &.selected {
      color: $col_orange;
      .sub-region {
        color: $col_orange;
      }
    }
  }
}
@media #{$desktop} {
  .prop,
  .cms,
  .seo,
  .lodge-form {
    .search-container {
      .box{
        margin: 0 0 0 .625rem;
        .select {
          margin: 0;
          box-shadow: 0 .063rem .125rem rgba(0, 0, 0, 0.3);
        }
      }
      .box input.btn {
        height: 3.125rem;
        box-shadow: 0 .063rem .125rem rgba(0, 0, 0, 0.3);
        padding: 0 1rem;
      }
    }
  }
  .search-form {
    padding: 1.25rem 0;
    .region-container input,
    .box input,
    .box .select {
      box-shadow: none;
    }
    .box input.btn,
    .box .select{
      border: .063rem solid #9B9B9B;
    }
  }
}
</style>